import type { FunctionComponent } from 'react';
import type { ComparisonTableFragment } from '../../graphql/fragments/ComparisonTableFragment.graphql';
import styles from './comparison-table.module.scss';
import { DesktopComaprisonTable } from './desktop-comparison-table';
import { MobileComaprisonTable } from './mobile-comparison-table';

/**
 * A component that displays a table to compare different products, plans, features, benefits, etc...
 */
const ComparisonTable: FunctionComponent<Omit<ComparisonTableFragment, 'type' | 'sys'>> = props => <div className={styles.section} data-sentry-component="ComparisonTable" data-sentry-source-file="comparison-table.tsx">
        <div className={styles.outer}>
            <div className={styles.inner}>
                <DesktopComaprisonTable {...props} data-sentry-element="DesktopComaprisonTable" data-sentry-source-file="comparison-table.tsx" />
                <MobileComaprisonTable {...props} data-sentry-element="MobileComaprisonTable" data-sentry-source-file="comparison-table.tsx" />
            </div>
        </div>
    </div>;
export default ComparisonTable;